module.exports = CommonFunctions;


function CommonFunctions() {}

CommonFunctions.prototype.checkURL = async function(permissionDetails,searchUrl) {
  try{
    let finalURLStatus = {};
    searchUrl.forEach((item) => {
      function isBigEnough(findURL) {
        if(findURL.submenu.length>0){
          return findURL.submenu.some(isBigChildEnough);
        }
        return findURL.url == item;
      }
      function isBigChildEnough(findURL) {
        if(findURL.url != item){
          return findURL.submenu.some(isBigChildEnough);
        }
        return findURL.url == item;
      }
      finalURLStatus[item] = permissionDetails.some(isBigEnough);
    });
    return finalURLStatus;
  } catch (DBException) {
    console.log(DBException);
    return false;
  }
}

CommonFunctions.prototype.getRandomChar = function(length) {
  try{
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  } catch (DBException) {
    return false;
  }
}
CommonFunctions.prototype.alternateCharacterString = function(password) {
  try{
    let finalString = '';
    for ( let i = 0; i < password.length; i++ ) {
       finalString += password.charAt(i);
       finalString += CommonFunctions.prototype.getRandomChar(1)
    }
    return finalString;
  } catch (DBException) {
    return false;
  }
}

CommonFunctions.prototype.encryptData = function(password) {
  try{
    let string1 = CommonFunctions.prototype.getRandomChar(16);
    let string2 = CommonFunctions.prototype.alternateCharacterString(password);
    encryptedPasswordString =  string1 + string2;
    return encryptedPasswordString;
  } catch (DBException) {
    return false;
  }
}


CommonFunctions.prototype.decryptText = function (encryptedPasswordString) {
  try {
    let substring1 = encryptedPasswordString.substring(16);
    let finalString = '';
    for ( let i = 0; i < substring1.length; i++) {
       finalString += substring1.charAt(i);
       i=i+1;
    }
    return finalString;
  } catch (e) {
    return false;

  }
}



// WEBPACK FOOTER //
// ./src/CommonFunctions.js